import type { Job } from "@freeconvert/freeconvert-node/dist/types";

export const getExportTaskFromJob = (job: Job) => job.tasks?.find(({ name }) => name === "exportTask");
